import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CaseService } from 'src/app/shared/services/case.service';
import { LookupService } from 'src/app/shared/services/lookup.service';
import { NotificationService } from 'src/app/shared/services/notification.service';
import { SharedHttpService } from 'src/app/shared/services/shared-http.service';

import * as moment from 'moment';
import { Observable } from 'rxjs';
//import { it } from 'node:test';


@Component({
  selector: 'app-penalities',
  templateUrl: './penalities.component.html',
  styleUrls: ['./penalities.component.scss']
})
export class PenalitiesComponent implements OnInit {

 
  caseObject: any;
  DecsionTypeArr: any;
  closeResult: string;
  decsionTypeId: any;
  penaltyId: any;
  voteList: any;
  decsionDescription
  decsionId
  lengthVote: any;
  roleId: any;
  DecsionOList: any;
  PenaltyArr: any;
    amount: any;
    isFinancial: any;
    description: any;
    file: any;
  decisionTypeName:string;
  itemPrint:any;
  violationId:any;
  violationArr:any=[];

  createInvoiceWithAmount: boolean = true;
  isOnCR: boolean = true;
  offenderName: any;
  offenderId: any=null;
  offenderIds: any = [];
  typeArr: any = [
    { id: 1, text: "عقوبة على المنشأة", isSelected: true },
    { id: 2, text: "عقوبة على الأفراد", isSelected: false }
  ];
  OffenderFromCR: any;
  CasePenaltiesList: any;
  penaltyDescription: any;
  OffenderList: any;
  deleteitem: any;
  casePenaltyId: any;
  penaltyStatusId: any;
  saveDecsion:boolean=false;
  casePenaltyEdited:any;
  casePenaltyEditedTypeArr=[
    { id: 1, text:  "عقوبة على المنشأة" , isSelected: false },
    { id: 2, text:  "عقوبة على الأفراد" , isSelected: false }
  ];
  memberTypesArr:any=[];
  memberTypeId:any;



  offenderEdited:any;

  
  
  penaltystatusArr: any;
  fileLoad: any;
  FileName: any;
  decsiontypeId: any;
  itemNew: any;
  descriptionDesion: any;
  maxAmountPenality:any;
  minAmountPenality:any;
  @Input() loadDataFP: Observable<any>;
  memberType: any;
  fillterList: any;
  inputMethod: string = 'onCr';
  isOnCRViolation: boolean;
  personsInCompanyAddPersonModalArr: any;
  crRelatedPrsonName: any;
  crRelatedPrsonId: any;
  caseDetails: any;
  

  constructor(private lookupService: LookupService,public caseService: CaseService, public sharedService: SharedHttpService, public toastr: NotificationService, public router: Router, private modalService: NgbModal) {
    this.roleId = this.sharedService.CurrentRoleId;

  }
  ngOnInit(): void {
    this.isOnCRViolation=true;
    let url: any = `api/Lookup/GetLookup?key=decsiontype`;
    this.sharedService.get(url).subscribe(result => {
      this.DecsionTypeArr = result;
    });
    this.caseDetails = this.caseService.case;

    let urlGet: any = `api/Lookup/GetLookup?key=penaltystatus`;
    this.sharedService.get(urlGet).subscribe(result => {
      this.penaltystatusArr = result;
    });
    let getUrl: any = `api/Penalty/GetAllAsLookup`;
    this.sharedService.get(getUrl).subscribe(result => {
      this.PenaltyArr = result;
    });
    this.sharedService.get(`api/Company/GetCompanyById?Id=${this.caseDetails.companyId}`).subscribe(res => {
      this.personsInCompanyAddPersonModalArr = res.crRelatedPrsons;
    })
    this.loadDataFP.subscribe((data) => {
      setTimeout(() => {
this.loadData();
      }, 100);

  });
  }
    decsionNumber: any="";
     decsionhijriYear: any="";
  loadData() {
    this.caseObject = this.caseService.getCaseData();
    // this.sharedService.get('api/Lookup/GetLookup?key=caseoffendertypes').subscribe(result=>{
    //   this.memberTypesArr=result;

      this.sharedService.get(`api/Violation/GetAllCaseViolations?caseId=${this.caseObject.caseId}`).subscribe(result=>{
        this.violationArr=result;

      // })
    });
    this.memberTypesArr = this.lookupService.getLockup('membertype');
    this.memberTypesArr.splice(0,4);
    let url: any = `api/Vote/GetCaseVotes?eCaseId=${this.caseObject.eCaseId}`;
    this.sharedService.get(url).subscribe(result => {
  
      this.voteList = result;
      this.lengthVote = result.length;
      console.log("voteList", result);
      console.log("roleId", this.roleId);

      // userRoleId =>6 or 7
    });

    let getUrl: any = `api/Decsion/GetCaseDecsion?eCaseId=${this.caseObject.eCaseId}`;
    this.sharedService.get(getUrl).subscribe(result => {
      this.DecsionOList = result;
      if (this.DecsionOList != null) {
          this.decsionId = result.decsionTypeId;

          this.descriptionDesion = result.decsion;
          this.decsionNumber = (result.decsionNumber!=null)? result.decsionNumber:"";
          this.decsionhijriYear = (result.decsionNumber != null) ?  result.hijriYear:"";
          this.decsiontypeId = (result.decsionTypeId != null) ? result.decsionTypeId :"";
          console.log("decsiontypeId", this.decsiontypeId);
          if(result.decsionTypeId==1){
            this.decisionTypeName="عدم ثبوت المخالفة";
          }
          if(result.decsionTypeId==2){
            this.decisionTypeName="ثبوت المخالفة";
          }


      }
    });


    let getList: any = `api/CasePenalty/GetCasePenalties?eCaseId=${this.caseObject.eCaseId}`;
    this.sharedService.get(getList).subscribe(result => {
      console.log("CasePenaltiesList", result);
      this.CasePenaltiesList = result;


    });
    // this.isOnCR=false;
    if(this.caseObject.offenderTypeId==2){
      this.itemNew = this.typeArr[1];
      this.isAllSelected(this.itemNew);
    }
  }
  open(content: any) {

    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true }).result.then((result) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

    });
    }
    selectPersonINCompany(event) {
      if (event) {
           
          this.crRelatedPrsonId = event.id;
          this.crRelatedPrsonName = event.name;
      }
      else {
        
          this.crRelatedPrsonId = undefined;
          this.crRelatedPrsonName = undefined;
      }
    }
    inputMethodSelect(string) {
      this.inputMethod = string;
      if(this.inputMethod=='onCr'){
        this.isOnCRViolation=true;
        
      }else{
        this.isOnCRViolation=false;

      } 
    }

    openlarg(content: any) {

        this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title', centered: true, size: 'lg' }).result.then((result) => {
            this.closeResult = `Closed with: ${result}`;
        }, (reason) => {
            this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;

        });
    }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  CreateDecsion() {
    let url: any = `api/Decsion/InsertCaseDecsion`;
    console.log("descriptionDesion",this.descriptionDesion);
    let body =  {
      "decsionTypeId": this.decsionId,
      "caseId": this.caseObject.caseId,
      "decsion": this.descriptionDesion
    };
    this.sharedService.post(url,body).subscribe((response) => {
      console.log("response", response);
      let formData: FormData = new FormData();
      formData.append('statusId', '9');
      formData.append('description',this.descriptionDesion);
      formData.append('eCaseId', this.caseObject.eCaseId);
      
      this.sharedService.post('api/Delegate/InsertDelegation', formData).subscribe(
        (response) => {                       
          this.saveDecsion=true;
          this.loadData();
          let getUrlDecision: any = `api/Decsion/GetCaseDecsion?eCaseId=${this.caseObject.eCaseId}`;
          this.sharedService.get(getUrlDecision).subscribe(result => {
            this.DecsionOList = result;
            this.decsionNumber = result.decsionNumber;
            this.decsionhijriYear = result.hijriYear;
            // let stringToastr =`${this.sharedService.getTranslatedKey("SaveDecsionSuccessfully")} ${this.sharedService.getTranslatedKey("WithNumber")} ${this.decsionNumber} ${this.sharedService.getTranslatedKey("ForYear")} ${this.decsionhijriYear} `
            // this.toastr.showSuccess(stringToastr, this.sharedService.getTranslatedKey("Success"));
            this.modalService.dismissAll();
            this.router.navigate([`/case/decision-done/${this.decsionNumber}`]);
          });
        },
          (error) => {                              
            this.sharedService.showErrorKey("Notsaved");
  
       
          }
      );
     

      
    },(error) => {                              
      console.error('error')
      
 
    }
    );
  }


  caseOffenderTypeIdSelected(event){
    this.memberType=event.id;
    this.offenderIds=[];
    if(this.casePenaltyEdited != undefined){
      this.offenderEdited=undefined;
    }

    this.sharedService.get(`api/CaseMember/GetCaseMembers?ecaseId=${this.caseObject.eCaseId}`).subscribe(res => {
      let arr :any=[];
      this.OffenderList=res;
      this.fillterList=res.filter(el => el.memberTypeId == this.memberType);
      
  
      if(this.casePenaltyEdited !=undefined){
        this.casePenaltyEdited.casePenaltyOffenders=[];
      }


      if(this.casePenaltyEdited !=undefined){
        this.casePenaltyEdited.casePenaltyOffenders=arr.filter(el => el.memberTypeId == event.id);
      }
      
    })

    
  }
  isAllSelected(item) {
    this.typeArr.forEach(val => {
      if (val.id == item.id) val.isSelected = !val.isSelected;
      else {
        val.isSelected = false;
      }
    });
    if (item.id == 2) {
      this.isOnCR = false;
      this.sharedService.get(`api/CaseMember/GetCaseMembers?ecaseId=${this.caseObject.eCaseId}`).subscribe(res => {
        this.OffenderList = res;
      })
    } else {
      this.isOnCR = true;
       // this.offenderId = this.caseObject.offenderId;
    }
  }

  isAllSelectedEdited(item) {
    this.casePenaltyEditedTypeArr.forEach(val => {
      if (val.id == item.id) val.isSelected = !val.isSelected;
      else {
        val.isSelected = false;
      }
    });
    if (item.id == 2) {
      this.casePenaltyEdited.isOnCR = false;
      this.sharedService.get(`api/CaseMember/GetCaseMembers?ecaseId=${this.caseObject.eCaseId}`).subscribe(res => {
        this.OffenderList = res;
      })
    } else {
      this.casePenaltyEdited.isOnCR = true;
       // this.offenderId = this.caseObject.offenderId;
    }
  }


  CreatePenalty(modal) {
    this.isFinancial=true;
    this.openlarg(modal);
  }

    OnCreatePenalty() {
      let url: any = `api/CasePenalty/AddCasePenalty`;
      let casePenaltyOffenders: any = [];
      if (this.offenderIds){
          casePenaltyOffenders.push({ "offenderId": this.offenderIds })

      }
      //     this.offenderIds.forEach(val => {
      //       casePenaltyOffenders.push({ "offenderId": val })
      // });
      
    this.sharedService.post(url, {
      "penaltyId": this.penaltyId,
      "caseId": this.caseObject.caseId,
      "offenderId": this.offenderId,
      "createInvoiceWithAmount": this.createInvoiceWithAmount,
      "amount": this.amount,
      "casePenaltyOffenders": casePenaltyOffenders,
      "isFinancial": this.isFinancial,
      "description":this.penaltyDescription,
      "memberTypeId":this.memberTypeId,
      "violationId":this.violationId,
      "isOnCR": this.isOnCRViolation,
      "crRelatedPrsonId": this.crRelatedPrsonId,
      "crRelatedPrsonName": this.crRelatedPrsonName,
    
    }).subscribe(response => {
      this.loadData();
        this.sharedService.showSuccessKey("PenaltyCreatedSuccessfully");

        this.penaltyId = null;
        this.offenderId = null;
        this.offenderName = null;
        this.violationId=undefined;
        this.offenderIds=[];
        this.createInvoiceWithAmount = false;
        this.penaltyDescription = "";
        this.memberTypeId=null;
        this.amount = 0;
        this.crRelatedPrsonId=undefined;
        this.crRelatedPrsonName=undefined;

    },
    );
    this.modalService.dismissAll();

  } 
    selectItem(event) {

     console.log(event);
        if (event) {
          this.maxAmountPenality=event.maxAmount;
          this.minAmountPenality=event.minAmount;
          if( this.casePenaltyEdited){
            this.casePenaltyEdited.amount=undefined;
          }


            this.penaltyDescription = event.penaltyDescription;
            this.amount = event.penaltyAmount;
            this.isFinancial = event.isFinancial;
        }else{
          this.amount=undefined;
        }





    }
  DeletePenalty(item: any, mymodal) {
    this.open(mymodal);
    this.deleteitem = item;
  }

  onDeletePenalty() {
    let url = `api/CasePenalty/DeleteCasePenalty?CasePenaltyId=${this.deleteitem.casePenaltyId}`;
    this.sharedService.get(url).subscribe((res) => {
      console.log("res",res);
      this.modalService.dismissAll();
      this.loadData();

    });
  }

  EditPenalty(item, modal) {
    console.log(item)
   this.isOnCRViolation=item.isOnCR;
   if(this.isOnCRViolation=true){
    this.inputMethod=='onCr';
  }else{
    this.inputMethod=='onPerson';

  } 
  // this.inputMethodSelect(this.inputMethod);
   this.crRelatedPrsonId=item.crRelatedPrsonId;
   this.crRelatedPrsonName=item.crRelatedPrsonName;
    let penalty=this.PenaltyArr.filter(el=>item.penaltyId===el.penaltyId)
    this.maxAmountPenality=penalty[0].maxAmount;
    this.minAmountPenality=penalty[0].minAmount;
    this.isFinancial=item.isFinancial;
    this.offenderEdited=undefined;
    this.casePenaltyEdited={...item};
    
    
    this.sharedService.get(`api/CaseMember/GetCaseMembers?ecaseId=${this.caseObject.eCaseId}`).subscribe(res => {
      let arr :any=[];
      arr= res;
      this.OffenderList=arr.filter(el => el.memberTypeId == res.memberTypeId);
      this.casePenaltyEdited.casePenaltyOffenders=arr;
    })
  //   this.casePenaltyEdited.casePenaltyOffenders.forEach(val => {
  //     this.offenderEdited=val.offenderId;
  //     console.log('offender',val)
  //     console.log(this.offenderEdited)
  //     console.log(this.casePenaltyEdited.casePenaltyOffenders)
  //     console.log(this.casePenaltyEdited)


  // } )

    // this.casePenaltyId=item.casePenaltyId;
    // this.penaltyStatusId=item.penaltyStatusId;
    this.openlarg(modal);
  }

  onEditPenalty() {
    console.log(this.offenderEdited);
    let url: any = `api/CasePenalty/UpdateCasePenalty`;
      let casePenaltyOffenders: any = [];


      casePenaltyOffenders.push({ offenderId: this.offenderEdited })
      // this.offenderEdited.forEach(val => {
      //   console.log(casePenaltyOffenders)
      // });


      if (this.casePenaltyEdited.isOnCR) {
          casePenaltyOffenders = [];
      }
    let obj = {
      "casePenaltyId":this.casePenaltyEdited.casePenaltyId,
      "isOnCR": this.casePenaltyEdited.isOnCR,
      "penaltyId": this.casePenaltyEdited.penaltyId,
      "caseId": this.caseObject.caseId,
      "createInvoiceWithAmount": this.casePenaltyEdited.createInvoiceWithAmount,
      "amount": this.casePenaltyEdited.amount,
      "casePenaltyOffenders": casePenaltyOffenders,
      "description":this.casePenaltyEdited.description,
      "memberTypeId":this.casePenaltyEdited.memberTypeId,
      "violationId":this.casePenaltyEdited.violationId,
      "isFinancial": this.isFinancial,
      "crRelatedPrsonId": this.crRelatedPrsonId,
      "crRelatedPrsonName": this.crRelatedPrsonName,
    
    }
    console.log(obj)
    this.sharedService.post(url,obj).subscribe(response => {
      this.loadData();
      // this.toastr.showSuccess('تم تعديل العقوبة بنجاح', this.sharedService.getTranslatedKey("Success"));
    });
    this.modalService.dismissAll();
    
  }
  Recivers1: any = [];
  ShowRecivers(item, modal) {
    this.itemPrint=item;

        this.Recivers1 = []; 
        this.sharedService.get(`api/Case/GetPenaltyRecivers?CasePenaltyId=${item.casePenaltyId}`).subscribe(res => {
            this.Recivers1 = res;
            console.log(this.Recivers1);
            this.openlarg(modal);
        });

  }
  notCreatePenalty(){
    this.penaltyId=undefined;
    this.penaltyDescription='';
    this.modalService.dismissAll();
  }
  print(){
    let penaltyTitle=this.itemPrint.isFinancial? 'مالية' :'إدارية';
    let caseOffenderTypeName = this.itemPrint.caseOffenderTypeName !=null ? this.itemPrint.caseOffenderTypeName : "";
    let amount = this.itemPrint.amount ==0 ? '0':this.itemPrint.amount;
    let sadadNumber = this.itemPrint.sadadNumber==null?'لا يوجد':this.itemPrint.sadadNumber;
    let offenderName = caseOffenderTypeName === "على المنشأة" ? `<b>إسم المنشأة:</b><span>${this.caseObject.offenderName}</span>
    ` : "";
   
    let body = ` <div style="display:flex;align-items: center;flex-direction:column; justify-content:center">
    <div style="width:270px;display:flex">
    <img style="width:30%; margin:auto;" class="img-fluid for-light" src="../../../../../../assets/images/mclogo.png" alt="looginpage">
    </div>
    <h2 style="font-weight: bold">تقرير تبليغ</h2>
      
    </div>
    <div style="display: flex;justify-content:space-between;margin-top: 50px;margin-bottom:25px">
      <div>
        <b>رقم المخالفة:</b> <span>${this.caseObject.caseNumber}</span>
      </div>
      <div>
        <b>رقم القرار:</b><span>${this.decsionNumber}</span>
      </div>
    </div> 
    <div style="display: flex;justify-content:space-between;margin-top:25px">
    
    <div>
      <b>نوع المخالف:</b><span>${caseOffenderTypeName}</span>
    </div>
    <div>
    ${offenderName}
    </div>
  </div>
  <div>
    <b> عنوان العقوبة :</b><span>${penaltyTitle}</span>
  </div>
  <div>
      <b> وصف العقوبة :</b><span>${this.itemPrint.description}</span>
  </div>
  <div>
      <b> رقم الفاتورة :</b><span>${sadadNumber}</span>
  </div>
  <div>
    <b> قيمة الفاتورة :</b><span>${amount}</span>
  </div>
    `;

  // table
  let tableBody='';
  this.Recivers1.map((el:any)=>{
    let isViewed = el.isViewed?"نعم":"لا";
    let viewedOn = el.isViewed? moment(el.createdOn).format('YYYY-MM-DD h:mm a') : "";
      let row =` 
 <br/>
  <b> رقم الهوية :  </b>   ${el.nid }  <br/>

   <b>الاسم :</b>   ${el.name}   <br/>
  <b>الرسالة :</b>   ${el.nabaaMessage}   <br/>

    <b>تاريخ البليغ :</b>     ${moment(el.createdOn).format('YYYY-MM-DD h:mm a')}    <br/>



       <b>  تم الاطلاع :</b>     ${isViewed}   <br/>

   
       <b>  تاريخ الاطلاع :</b>      ${viewedOn}  
     `;
    tableBody = tableBody.concat(row);


  });
      let table =   ` <div style="padding:20px:width:100%;background-color:#F8F8F8;text-align:center"><h2 style="font-weight:bold">تفاصيل التبليغ</h2></div>
       ${tableBody}
    
    `
  body= body.concat(table);

    



    let contents = `
      <html>
        <head>


          <style  type="text/css">
            @media print {@page{ margin: .75in .5in;  }}
           

   @font-face {
                font-family: "Noto Naskh Arabic";
                src: url("../../../../../assets/fonts/Noto_Naskh_Arabic/NotoNaskhArabic-VariableFont_wght.ttf") format("truetype");
              }

body{  font-family: "Noto Naskh Arabic";} 
          </style>
        </head>
        <body dir="rtl"> ${body}</body>
      </html>`;

    let mywindow = window.open('', '_blank', 'top=0,left=0,height=100%,width=auto');
    mywindow!.document.open();
    let is_chrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
    mywindow!.document.write(contents);

    if (is_chrome) {
      setTimeout(function () {
        mywindow!.document.close();
        mywindow!.focus();
        mywindow!.print();
        // mywindow.close();
 
      }, 1000); 
    } else {
      mywindow!.document.close();
      mywindow!.focus();
      mywindow!.print();
      // mywindow.close();
    }
  
    
  }

}
